import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  icon: '💭',
  text: '"Algún día nos casamos… pero sin fecha, sin plan y sin anillo."'
}, {
  icon: '⏳',
  text: '"Estamos bien así, ¿para qué cambiar lo que tenemos?"'
}, {
  icon: '😔',
  text: '"No es el momento, necesitamos más dinero, más tiempo…"'
}, {
  icon: '🔇',
  text: '"Cada vez que sacas el tema, él lo evita o se incomoda."'
}];
export function PainPointSection() {
  return <section className="py-14 px-6 bg-blush relative" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-104">
          <p className="text-burgundy font-bold uppercase tracking-widest text-sm mb-3" data-id="element-105">
            ¿Te suena familiar?
          </p>
          <h2 className="md:text-4xl font-bold text-[24px] text-burgundy" data-id="element-106">
            Llevas meses esperando una respuesta
            <br className="hidden md:block" data-id="element-107" /> que nunca llega
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 mb-10" data-id="element-108">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 shadow-lg border-l-4 border-gold flex items-start gap-3" data-id="element-109">
              <span className="text-2xl flex-shrink-0" data-id="element-110">{point.icon}</span>
              <p className="text-gray-800 text-base italic font-serif" data-id="element-111">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center relative py-4" data-id="element-112">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-burgundy/20" data-id="element-113"></div>
          <p className="text-lg md:text-xl text-gray-800 max-w-3xl mx-auto leading-relaxed" data-id="element-114">
            <strong className="text-burgundy font-serif" data-id="element-115">
              La verdad incómoda:
            </strong>{' '}
            No estás pidiendo demasiado. Estás pidiendo{' '}
            <em className="text-gold font-serif" data-id="element-116">dirección</em>. Y mereces
            saberla.
          </p>
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-burgundy/20" data-id="element-117"></div>
        </motion.div>
      </div>
    </section>;
}